// English translations
export const en = {
  // Navigation
  nav: {
    dashboard: 'Dashboard',
    chronicPrescriptions: 'Chronic Prescriptions',
    planOfCare: 'Plan of Care Hub',
    privatePractice: 'Private Practice Hub',
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout',
    notifications: 'Notifications',
    portalTitle: 'Healin Healthcare Provider Portal'
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Welcome to your healthcare provider dashboard',
    welcomeBack: 'Welcome back',
    overview: "Here's an overview of your practice today",
    goodMorning: 'Good morning, Dr. Smith',
    todayOverview: 'Here\'s your overview for today, {date}',
    pendingPrescriptions: 'Pending Prescriptions',
    upcomingAppointments: 'upcoming appointments',
    upcomingAppointmentsCard: 'Upcoming Appointments',
    activePatients: 'Active Patients',
    newNotifications: 'New Notifications',
    viewAll: 'View All',
    viewCalendar: 'View Calendar',
    patientDirectory: 'Patient Directory',
    recentNotifications: 'Recent Notifications',
    followUp: 'Follow-up',
    consultation: 'Consultation',
    checkUp: 'Check-up',
    newPrescriptionRequest: 'New prescription request from {patient}',
    appointmentRescheduled: 'Appointment rescheduled with {patient}',
    labResultsAvailable: 'Lab results available for {patient}',
    hoursAgo: '{hours} hours ago',
    daysAgo: '{days} day ago',
    totalPatients: 'Total Patients',
    totalAppointments: 'Total Appointments',
    revenue: 'Revenue',
    practiceInformation: 'Practice Information',
    address: 'Address',
    contact: 'Contact',
    noAddressProvided: 'No address provided',
    noPhoneProvided: 'No phone provided',
    noEmailProvided: 'No email provided'
  },

  // Chronic Prescriptions
  chronicPrescriptions: {
    title: 'Chronic Prescriptions Hub',
    subtitle: 'Manage and issue chronic prescription requests from patients',
    availableRequests: 'Available Requests ({count})',
    myClaimedRequests: 'My Claimed Requests ({count})',
    myIssuedRequests: 'My Issued Requests ({count})',
    refresh: 'Refresh',
    backToList: '← Back to list',
    dateOldestFirst: 'Date (Oldest First)',
    dateNewestFirst: 'Date (Newest First)',
    statusAZ: 'Status (A-Z)',
    patientNameAZ: 'Patient Name (A-Z)',
    noSort: 'No Sort',
    claimSuccessMessage: 'Prescription request claimed successfully!',
    claimRefreshWarning: 'Prescription claimed but failed to refresh data. Please refresh manually.',
    noAvailableRequests: 'No available prescription requests at the moment.',
    noClaimedRequests: "You haven't claimed any prescription requests yet.",
    noIssuedRequests: "You haven't issued any prescription requests yet.",
    prescriptionClaimedSuccess: 'Prescription request claimed successfully!',
    prescriptionIssuedSuccess: 'Successfully issued',
    medications: 'medication(s)',
    sortOptions: {
      dateNewest: 'Date (Newest First)',
      dateOldest: 'Date (Oldest First)',
      status: 'Status (A-Z)',
      patient: 'Patient Name (A-Z)',
      none: 'No Sort'
    }
  },

  // Plan of Care Hub
  planOfCare: {
    title: 'Plan of Care Hub',
    subtitle: 'Manage and issue medical procedure requests from patients',
    availableRequests: 'Available Requests ({count})',
    myClaimedRequests: 'My Claimed Requests ({count})',
    myIssuedRequests: 'My Issued Requests ({count})',
    refresh: 'Refresh',
    backToList: '← Back to list',
    dateOldestFirst: 'Date (Oldest First)',
    dateNewestFirst: 'Date (Newest First)',
    statusAZ: 'Status (A-Z)',
    patientNameAZ: 'Patient Name (A-Z)',
    noSort: 'No Sort',
    claimSuccessMessage: 'Procedure request claimed successfully',
    issueSuccessMessage: 'Successfully issued {count} procedure(s)',
    noAvailableRequests: 'No available procedure requests at the moment.',
    noClaimedRequests: "You haven't claimed any procedure requests yet.",
    noIssuedRequests: "You haven't issued any procedure requests yet.",
    procedureTypeTitle: 'Procedure Type Legend:',
    laboratoryType: 'Laboratory',
    complementaryExamsType: 'Complementary Exams',
    surgeryType: 'Surgery',
    consultationType: 'Consultation',
    therapyType: 'Therapy',
    othersType: 'Others'
  },

  // Private Practice Hub
  privatePractice: {
    title: 'Private Practice Hub',
    subtitle: 'Video Appointment Management',
    scheduledAppointments: 'Scheduled Appointments',
    upcomingAppointments: 'Upcoming Appointments',
    ongoingAppointments: 'Ongoing Appointments',
    completedAppointments: 'Completed Appointments',
    sortBy: 'Sort by',
    date: 'Date',
    patientName: 'Patient Name',
    status: 'Status',
    refresh: 'Refresh',
    noScheduledAppointments: 'No scheduled appointments found',
    noScheduledSubMessage: 'New scheduled appointments will appear here when patients book appointments',
    noUpcomingAppointments: 'No upcoming appointments this week',
    noUpcomingSubMessage: 'Confirmed appointments for this week (Sunday-Saturday) will appear here',
    noOngoingAppointments: 'No ongoing appointments found',
    noOngoingSubMessage: 'Active appointments currently in progress will appear here',
    noCompletedAppointments: 'No completed appointments found',
    noCompletedSubMessage: 'Completed appointments will appear here',
    appointmentCompleted: 'Appointment marked as completed!',
    calendarView: 'Calendar View'
  },

  // Profile
  profile: {
    title: 'Doctor Profile',
    subtitle: 'Manage your professional information and credentials',
    refresh: 'Refresh',
    editProfile: 'Edit Profile',
    activeProvider: 'Active Provider',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    medicalSpecialty: 'Medical Specialty',
    licenseNumber: 'License Number',
    hospitalClinic: 'Hospital/Clinic',
    address: 'Address',
    professionalBio: 'Professional Bio',
    bioPlaceholder: 'Describe your experience, specializations, and approach to patient care...',
    contactInformation: 'Contact Information',
    professionalDetails: 'Professional Details',
    accountInformation: 'Account Information',
    doctorId: 'Doctor ID',
    profileCreated: 'Profile Created',
    lastUpdated: 'Last Updated',
    specialty: 'Specialty',
    notProvided: 'Not provided',
    notSpecified: 'Not specified',
    profileSavedSuccess: 'Profile saved successfully!',
    profileSaveError: 'Failed to save profile',
    invalidDoctorId: 'Invalid doctor ID',
    healthcareProvider: 'Healthcare Provider',
    availability: 'Availability'
  },

  // Common
  common: {
    loading: 'Loading...',
    retry: 'Retry',
    retrying: 'Retrying...',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    patient: 'Patient',
    doctor: 'Doctor'
  }
};

// Portuguese translations
export const pt = {
  // Navigation
  nav: {
    dashboard: 'Painel',
    chronicPrescriptions: 'Prescrições Crónicas',
    planOfCare: 'Hub de Plano de Cuidados',
    privatePractice: 'Hub de Prática Privada',
    profile: 'Perfil',
    settings: 'Configurações',
    logout: 'Sair',
    notifications: 'Notificações',
    portalTitle: 'Portal do Profissional de Saúde Healin'
  },

  // Dashboard
  dashboard: {
    title: 'Painel',
    subtitle: 'Bem-vindo ao seu painel de profissional de saúde',
    welcomeBack: 'Bem-vindo de volta',
    overview: 'Aqui está uma visão geral da sua prática hoje',
    goodMorning: 'Bom dia, Dr. Smith',
    todayOverview: 'Aqui está a sua visão geral para hoje, {date}',
    pendingPrescriptions: 'Prescrições Pendentes',
    upcomingAppointments: 'consultas agendadas',
    upcomingAppointmentsCard: 'Consultas Agendadas',
    activePatients: 'Pacientes Activos',
    newNotifications: 'Novas Notificações',
    viewAll: 'Ver Todas',
    viewCalendar: 'Ver Calendário',
    patientDirectory: 'Directório de Pacientes',
    recentNotifications: 'Notificações Recentes',
    followUp: 'Seguimento',
    consultation: 'Consulta',
    checkUp: 'Exame de rotina',
    newPrescriptionRequest: 'Nova solicitação de prescrição de {patient}',
    appointmentRescheduled: 'Consulta remarcada com {patient}',
    labResultsAvailable: 'Resultados laboratoriais disponíveis para {patient}',
    hoursAgo: 'há {hours} horas',
    daysAgo: 'há {days} dia',
    totalPatients: 'Total de Pacientes',
    totalAppointments: 'Total de Consultas',
    revenue: 'Receita',
    practiceInformation: 'Informações da Prática',
    address: 'Endereço',
    contact: 'Contacto',
    noAddressProvided: 'Nenhum endereço fornecido',
    noPhoneProvided: 'Nenhum telefone fornecido',
    noEmailProvided: 'Nenhum email fornecido'
  },

  // Chronic Prescriptions
  chronicPrescriptions: {
    title: 'Hub de Prescrições Crónicas',
    subtitle: 'Gerir e emitir pedidos de prescrições crónicas de pacientes',
    availableRequests: 'Pedidos Disponíveis ({count})',
    myClaimedRequests: 'Meus Pedidos Aceites ({count})',
    myIssuedRequests: 'Meus Pedidos Emitidos ({count})',
    refresh: 'Actualizar',
    backToList: '← Voltar à lista',
    dateOldestFirst: 'Data (Mais Antigo Primeiro)',
    dateNewestFirst: 'Data (Mais Recente Primeiro)',
    statusAZ: 'Estado (A-Z)',
    patientNameAZ: 'Nome do Paciente (A-Z)',
    noSort: 'Sem Ordenação',
    claimSuccessMessage: 'Pedido de prescrição aceite com sucesso!',
    claimRefreshWarning: 'Prescrição aceite mas falha ao actualizar dados. Por favor, actualize manualmente.',
    noAvailableRequests: 'Não há pedidos de prescrição disponíveis no momento.',
    noClaimedRequests: 'Ainda não aceitou nenhum pedido de prescrição.',
    noIssuedRequests: 'Ainda não emitiu nenhum pedido de prescrição.',
    prescriptionClaimedSuccess: 'Pedido de prescrição aceite com sucesso!',
    prescriptionIssuedSuccess: 'Emitido com sucesso',
    medications: 'medicamento(s)',
    sortOptions: {
      dateNewest: 'Data (Mais Recente Primeiro)',
      dateOldest: 'Data (Mais Antigo Primeiro)',
      status: 'Estado (A-Z)',
      patient: 'Nome do Paciente (A-Z)',
      none: 'Sem Ordenação'
    }
  },

  // Plan of Care Hub
  planOfCare: {
    title: 'Hub de Plano de Cuidados',
    subtitle: 'Gerir e emitir pedidos de procedimentos médicos de pacientes',
    availableRequests: 'Pedidos Disponíveis ({count})',
    myClaimedRequests: 'Meus Pedidos Aceites ({count})',
    myIssuedRequests: 'Meus Pedidos Emitidos ({count})',
    refresh: 'Actualizar',
    backToList: '← Voltar à lista',
    dateOldestFirst: 'Data (Mais Antigo Primeiro)',
    dateNewestFirst: 'Data (Mais Recente Primeiro)',
    statusAZ: 'Estado (A-Z)',
    patientNameAZ: 'Nome do Paciente (A-Z)',
    noSort: 'Sem Ordenação',
    claimSuccessMessage: 'Pedido de procedimento aceite com sucesso',
    issueSuccessMessage: 'Emitido com sucesso {count} procedimento(s)',
    noAvailableRequests: 'Não há pedidos de procedimentos disponíveis no momento.',
    noClaimedRequests: 'Ainda não aceitou nenhum pedido de procedimento.',
    noIssuedRequests: 'Ainda não emitiu nenhum pedido de procedimento.',
    procedureTypeTitle: 'Legenda dos Tipos de Procedimento:',
    laboratoryType: 'Laboratório',
    complementaryExamsType: 'Exames Complementares',
    surgeryType: 'Cirurgia',
    consultationType: 'Consulta',
    therapyType: 'Terapia',
    othersType: 'Outros'
  },

  // Private Practice Hub
  privatePractice: {
    title: 'Hub de Prática Privada',
    subtitle: 'Gestão de Consultas por Vídeo',
    scheduledAppointments: 'Consultas Agendadas',
    upcomingAppointments: 'Próximas Consultas',
    ongoingAppointments: 'Consultas em Curso',
    completedAppointments: 'Consultas Concluídas',
    sortBy: 'Ordenar por',
    date: 'Data',
    patientName: 'Nome do Paciente',
    status: 'Estado',
    refresh: 'Actualizar',
    noScheduledAppointments: 'Nenhuma consulta agendada encontrada',
    noScheduledSubMessage: 'Novas consultas agendadas aparecerão aqui quando os pacientes marcarem consultas',
    noUpcomingAppointments: 'Nenhuma consulta próxima esta semana',
    noUpcomingSubMessage: 'Consultas confirmadas para esta semana (Domingo-Sábado) aparecerão aqui',
    noOngoingAppointments: 'Nenhuma consulta em curso encontrada',
    noOngoingSubMessage: 'Consultas activas actualmente em progresso aparecerão aqui',
    noCompletedAppointments: 'Nenhuma consulta concluída encontrada',
    noCompletedSubMessage: 'Consultas concluídas aparecerão aqui',
    appointmentCompleted: 'Consulta marcada como concluída!',
    calendarView: 'Vista de Calendário'
  },

  // Profile
  profile: {
    title: 'Perfil do Médico',
    subtitle: 'Gerir as suas informações profissionais e credenciais',
    refresh: 'Actualizar',
    editProfile: 'Editar Perfil',
    activeProvider: 'Profissional Activo',
    firstName: 'Primeiro Nome',
    lastName: 'Último Nome',
    email: 'Email',
    phone: 'Telefone',
    medicalSpecialty: 'Especialidade Médica',
    licenseNumber: 'Número de Licença',
    hospitalClinic: 'Hospital/Clínica',
    address: 'Endereço',
    professionalBio: 'Biografia Profissional',
    bioPlaceholder: 'Descreva a sua experiência, especializações e abordagem ao cuidado do paciente...',
    contactInformation: 'Informações de Contacto',
    professionalDetails: 'Detalhes Profissionais',
    accountInformation: 'Informações da Conta',
    doctorId: 'ID do Médico',
    profileCreated: 'Perfil Criado',
    lastUpdated: 'Última Actualização',
    specialty: 'Especialidade',
    notProvided: 'Não fornecido',
    notSpecified: 'Não especificado',
    profileSavedSuccess: 'Perfil guardado com sucesso!',
    profileSaveError: 'Falha ao guardar o perfil',
    invalidDoctorId: 'ID de médico inválido',
    healthcareProvider: 'Profissional de Saúde',
    availability: 'Disponibilidade'
  },

  // Common
  common: {
    loading: 'A carregar...',
    retry: 'Tentar novamente',
    retrying: 'A tentar novamente...',
    save: 'Guardar',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Eliminar',
    confirm: 'Confirmar',
    close: 'Fechar',
    yes: 'Sim',
    no: 'Não',
    error: 'Erro',
    success: 'Sucesso',
    warning: 'Aviso',
    info: 'Informação',
    patient: 'Paciente',
    doctor: 'Médico'
  }
};

// Translation function
export const getTranslations = (language) => {
  return language === 'pt' ? pt : en;
};

// Hook to use translations
export const useTranslations = (language) => {
  return getTranslations(language);
}; 